import { useCallback } from 'react';
import { isProductBundle as isProductBundleUtil } from 'commerce-products-lib/utils/subject';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Map as ImmutableMap } from 'immutable';
import { ProductBundlesEditorIFrameModal } from 'products-iframe-lib/components/ProductBundlesEditorIFrameModal';
import { ProductsEditorIFrameModal } from 'products-iframe-lib/components/ProductsEditorIFrameModal';
import { useDeactivateProductAction } from '../../contexts/DeactivateProductActionContext';
import { useDeleteProductAction } from '../../contexts/DeleteProductActionContext';
import { usePreviewPanelCallbacks } from '../../contexts/PreviewPanelCallbacksContext';
import { useProductData } from '../../contexts/ProductDataContext';
import { useProductDeactivateModal } from '../../contexts/ProductDeactivateModalContext';
import { useProductDeleteModal } from '../../contexts/ProductDeleteModalContext';
import { useProductEditModal } from '../../contexts/ProductEditModalContext';
import { useProductId } from '../../contexts/ProductIdContext';
import { DeactivateProductModal } from './DeactivateProductModal';
import { DeleteProductModal } from './DeleteProductModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductHighlightModals = () => {
  const productId = useProductId();
  const {
    product,
    associatedBundles
  } = useProductData();
  const deleteProduct = useDeleteProductAction();
  const deactivateProduct = useDeactivateProductAction();
  const {
    onObjectUpdate
  } = usePreviewPanelCallbacks();
  const {
    isDeleteModalOpen,
    setIsDeleteModalOpen
  } = useProductDeleteModal();
  const {
    isEditModalOpen,
    setIsEditModalOpen
  } = useProductEditModal();
  const {
    isDeactivateModalOpen,
    closeDeactivateModal
  } = useProductDeactivateModal();
  const handleCloseDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(false);
  }, [setIsDeleteModalOpen]);
  const handleCloseDeactivateModal = useCallback(() => {
    closeDeactivateModal();
  }, [closeDeactivateModal]);
  const handleIframeMessage = useCallback(({
    payload
  }) => {
    switch (payload.type) {
      case 'PRODUCT_UPDATE_COMPLETE':
        // Iframe already handled the mutation, just notify preview panel
        onObjectUpdate({
          objectId: payload.productId,
          objectType: PRODUCT_TYPE_ID,
          properties: ImmutableMap(payload.updatedProperties.entries())
        });
        setIsEditModalOpen(false);
        break;
      case 'PRODUCT_BUNDLE_UPDATE_COMPLETE':
        // Same for bundles - iframe did the mutation, just notify preview panel
        onObjectUpdate({
          objectId: payload.productBundleId,
          objectType: PRODUCT_TYPE_ID,
          properties: ImmutableMap(payload.updatedProperties.entries())
        });
        setIsEditModalOpen(false);
        break;
      case 'EXIT':
        setIsEditModalOpen(false);
        break;
      default:
        break;
    }
  }, [setIsEditModalOpen, onObjectUpdate]);
  const isProductBundle = !!product && isProductBundleUtil(product);

  // The call for openDeactivateModal should already have checked whether product is a bundle and associatedBundles length but being defensive here
  const showDeactivateModal = isDeactivateModalOpen && product && associatedBundles && associatedBundles.length > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDeleteModalOpen && /*#__PURE__*/_jsx(DeleteProductModal, {
      onConfirm: deleteProduct,
      onReject: handleCloseDeleteModal
    }), showDeactivateModal && /*#__PURE__*/_jsx(DeactivateProductModal, {
      onConfirm: deactivateProduct,
      onReject: handleCloseDeactivateModal
    }), productId != null && (isProductBundle ? /*#__PURE__*/_jsx(ProductBundlesEditorIFrameModal, {
      show: isEditModalOpen,
      operation: "EDIT",
      objectId: productId,
      onMessage: handleIframeMessage
    }) : /*#__PURE__*/_jsx(ProductsEditorIFrameModal, {
      show: isEditModalOpen,
      operation: "EDIT",
      objectId: productId,
      onMessage: handleIframeMessage
    }))]
  });
};